export default __webpack_public_path__ + "6848bc6e7e0902a27502d7910504c55e.png";